import { getFragmentData } from '@e-socna/data-layer';

import { AlertMessages } from '../../components/AlertMessages';
import { DocumentEditorResolvers_QuickAccess_Mission_Fragment } from '../../components/DocumentEditor/resolvers/fragments/quick-access.fragment';
import { getLiveServiceUsagesGroups } from '../../components/DocumentEditor/resolvers/utils/mission-service-usages-groups.util';
import { useMissionReadyContext } from '../../contexts/MissionContext/hooks/useMissionReadyContext.hook';
import { getQuotationOptionGroups } from '../../forms/MissionQuotationInfoState/utils/quotation-option-groups.util';

import { buildQuotationOptionsReminder } from './utils/quotation-options-reminder.util';

export const QuotationOptionsReminder = () => {
  const { mission } = useMissionReadyContext();

  const quickAccess = getFragmentData(
    DocumentEditorResolvers_QuickAccess_Mission_Fragment,
    mission,
  );

  const reminder = buildQuotationOptionsReminder(
    getQuotationOptionGroups({
      liveGroups: getLiveServiceUsagesGroups(quickAccess),
      snapshotGroups: quickAccess.quotationInfo?.snapshot?.serviceUsagesGroups,
    }),
    quickAccess.quotationInfo?.snapshot?.selectedOptionGroupIds,
  );

  return reminder ? (
    <AlertMessages
      messages={reminder.messages}
      severity={reminder.severity}
      title={reminder.title}
    />
  ) : null;
};
